export const ListQueryKey = 'deposits';
export const DetailQueryKey = 'deposit';
export const Urls = {
  selectUrl: '/deposit/list',
  updateUrl: '/deposit/update',
  deleteUrl: '/deposit/delete',
  createUrl: '/deposit/create',
  detailUrl: '/deposit/info'
};